import { useTranslation } from 'react-i18next';

import type { TextChild } from '@ifs-gcp/core/models';

import { getTranslation } from '@/utils/translations';

import styles from './audit-title.module.scss';

type AuditTitleProps = {
  element: TextChild;
};

export const AuditTitle = ({ element }: AuditTitleProps) => {
  const {
    i18n: { language },
  } = useTranslation();

  const {
    type,
    props: { text },
  } = element;

  const paragraphClasses = [styles.paragraph, styles[element.props.align || 'left']].join(' ');

  if (type === 'header') {
    return <h1>{getTranslation(text, language)}</h1>;
  }

  return <p className={paragraphClasses}>{getTranslation(text, language)}</p>;
};
